import { Spinner } from "../spinner";

export const PageLoader = () => (
	<section data-testid="page-loader" className="flex justify-center pt-40">
		<Spinner size={80} />
	</section>
);
